import type { BusinessDataType, PipelineStepBusinessType } from '../context/BusinessContext'
import { buildHaystack } from './searchUtils'

//* Índice de busca: businessID => haystack normalizado (calculado 1x por carga de dados)
export type BusinessSearchIndex = Map<string, string>

//* Única definição do texto pesquisável de um negócio
export const businessHaystack = (business: PipelineStepBusinessType): string =>
    buildHaystack([
        String(business.id),
        business.title,
        business.subtitle,
        business.value,
        ...(business.products?.map(product => product.name) ?? []),
        ...(business.targets?.map(target => target.label) ?? []),
        business.company?.name,
        ...(business.contacts?.flatMap(contact => [contact.name, contact.email, contact.phone]) ?? []),
        business.description,
        ...(business.noteDescriptions ?? [])
    ])

//* Percorre pipelines => steps => business e pré-computa o haystack de cada negócio
export const buildBusinessSearchIndex = (data: BusinessDataType): BusinessSearchIndex => {
    const index: BusinessSearchIndex = new Map()

    for (const pipeline of data.pipelines) {
        for (const step of pipeline.steps) {
            for (const business of step.business) {
                index.set(String(business.id), businessHaystack(business))
            }
        }
    }

    return index
}
